export const initialState = {
  errorsToShow: [],
  lookup: {
    /*
      ACTION_TYPE: { errorObject }
    */
  },
  shown: false,
};
